import React from 'react';
import Navbar from '../components/Layouts/Navbar';
import PageTitleArea from '../components/Common/PageTitleArea';
import ImpressumDetails from '../components/impressum/ImpressumDetails';
import Haftungsausschluss from '../components/impressum/Haftungsausschluss'
import Footer from '../components/Layouts/Footer';
import PageSeo from '../components/Common/PageSeo';
import { useRouter } from 'next/router';
import { useTranslations } from '../locales/useTranslations';

const Impressum = () => {
    const { t } = useTranslations();
    const { locale } = useRouter();
    const baseUrl = locale === 'en' ? 'https://simplify-data.com' : 'https://simplify-data.de';
    return (
        <>
            <PageSeo
                title={t('impressum_page_title')}
                description={t('impressum_page_description')}
                canonical={`${baseUrl}/impressum/`}
                openGraph={{
                    url: `${baseUrl}/impressum/`,
                    title: t('impressum_page_title'),
                    description: t('impressum_page_description'),
                    images: [
                        {
                            url: `${baseUrl}/images/simplify-data.png`,
                            width: 1200,
                            height: 630,
                            alt: 'Simplify Data - ' + t('impressum_page_title'),
                            type: 'image/jpeg',
                        },
                    ],
                    siteName: t('impressum_page_title'),
                }}
                twitter={{
                    handle: '@simplify_data',
                    site: '@simplify_data',
                    cardType: 'summary_large_image',
                }}
                additionalMetaTags={[
                    {
                        name: 'robots',
                        content: 'index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1',
                    },
                    {
                        name: 'keywords',
                        content: t('impressum_page_keywords'),
                    },
                    {
                        name: 'author',
                        content: 'Simplify Data',
                    },
                    {
                        name: 'geo.region',
                        content: 'DE-SH',
                    },
                    {
                        name: 'geo.placename',
                        content: 'Kiel',
                    },
                    {
                        property: 'article:modified_time',
                        content: new Date().toISOString(),
                    },
                    {
                        name: 'format-detection',
                        content: 'telephone=no',
                    }
                ]}
                additionalLinkTags={[
                    {
                        rel: 'icon',
                        href: `${baseUrl}/images/favicon.png`,
                        type: 'image/png'
                    },
                    {
                        rel: 'alternate',
                        hrefLang: 'de',
                        href: 'https://simplify-data.de/impressum/'
                    },
                    {
                        rel: 'alternate',
                        hrefLang: 'en',
                        href: 'https://simplify-data.com/impressum/'
                    }
                ]}
            />


            <Navbar />
            <PageTitleArea
                pageTitle={t('impressum_page_title')}
                pageDescription={t('impressum_page_description')}
            />
            <ImpressumDetails />
            <Haftungsausschluss />
            <Footer />
        </>
    );
}

export default Impressum;